import { Text } from "@chakra-ui/react";

export function Review({ string, t, ...rest }) {
  return (
    <Text
      textAlign="center"
      color="white70"
      fontSize="11.3px"
      lineHeight="1.29"
      letterSpacing="-0.27px"
      {...rest}
    >
      {t(string)}
    </Text>
  );
}

export function Author({ string, t, ...rest }) {
  return (
    <Text
      textAlign="center"
      color="#fab500"
      fontSize="12px"
      lineHeight="1.22"
      letterSpacing="-0.27px"
      {...rest}
    >
      {t(string)}
    </Text>
  );
}
